var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.browserSize.sm === true || _vm.browserSize.xs === true)?_c('div',{staticClass:"about"},[_c('AboutMe')],1):_c('div',{staticClass:"about2"},[_c('AboutMe')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }